import { v4 as uuid } from 'uuid';

import {
    getLocalSettings,
    setLocalSettings,
    setSessionSettings,
    getSessionSettings,
} from './api';

export function showProgress (message) {
    if (message) {
        this.progressMessage = message;
        this.observed.progressMessage = uuid();
    }
    this.progressOpen = true;
    this.observed.progressOpen = uuid();
}

export function closeProgress () {
    const objCtx = this;

    setTimeout(() => {
        objCtx.progressOpen = false;
        objCtx.observed.progressOpen = uuid();
    }, 1000);
}


export function showAppProgress () {
    this.appProgressOpen = true;
    this.observed.appProgressOpen = uuid();
}

export function closeAppProgress () {
    this.appProgressOpen = false;
    this.observed.appProgressOpen = uuid();
}

export function getSettings () {
    return getLocalSettings();
}

export function setSettings (props) {
    setLocalSettings({
        ...getLocalSettings(),
        ...props,
    });
}

export function clearSettings () {
    setLocalSettings({});
}

export function getPageSettings (page) {
    const info = getLocalSettings();
    if (info.page && info.page[page]) {
        return info.page[page];
    }
}

export function setPageSettings (page, data) {
    const info = getLocalSettings();
    setLocalSettings({
        ...info,
        page: {
            ...info.page,
            [page]: data,
        },
    });
}


export function setSession (settings) {
    setSessionSettings(settings);
}

export function upsertSession (settings) {
    const stored = this.getSession();
    const newSettings = {
        ...stored,
        ...settings,
    };
    setSession(newSettings);
}

export function getSession () {
    return getSessionSettings();
}

export function updateTimezone (tz) {
    this.timezone = tz;
}

const actions = {
    showProgress,
    closeProgress,
    
    showAppProgress,
    closeAppProgress,

    getSettings,
    setSettings,
    clearSettings,

    getPageSettings,
    setPageSettings,

    setSession,
    getSession,
    upsertSession,

    updateTimezone,
};

export default actions;
